import Metis from "../metis";
import {escapeMetisVariables, unescapeMetisReturnObject} from "./escapeMetis";

const metis = new Metis();
const wp = wp_metis;

class Events {
  /**
   *
   * @returns {any}
   */
  async getKurseForTerminFilter() {
    const request = metis.metisRequest({
      query: `
        query{
          getKurseForTerminFilter {
              kursnr
              kursart {
                bezeichnung
              }
            }
        }`,
    });

    const response = await request;
    if (response) {
      return response.getKurseForTerminFilter;
    }
  }

  /**
   *
   * @returns {any}
   */
  async getUnterrichtsfaecherForTerminFilter() {
    const request = metis.metisRequest({
      query: `
        query{
         getUnterrichtsfaecherForTerminFilter {
            fachnr
            fachbez
          }
        }`,
    });

    const response = await request;
    if (response) {
      return response.getUnterrichtsfaecherForTerminFilter;
    }
  }


  /**
   *
   * @returns {any}
   */
  async getAnfragenForTermintausch(page, pagesize) {
    const request = metis.metisRequest({
      query: `
        query{
          getAnfragenForTermintausch(page:  ${page}, pagesize: ${pagesize}) {
              totalElements
              totalPages
              termintauschAnfragen {
                id
                terminZumTausch {
                  terminnr
                  veranstnr
                  kurs {
                    kursnr
                    kursart {
                      bezeichnung
                    }
                    kursbez
                    onlineanteil
                  }
                  raum {
                    raumnr
                  }
                  unterrichtsfach {
                    fachnr
                    fachbez
                  }
                  terminFarbe {
                    farbcode
                    bezeichnung
                  }
                  belegtbisz
                  belegtvonz
                  bezeichnung
                  datum
                  veranstvonz
                  veranstbisz
                  veranstort {
                    anzeigename
                  }
                  createTime
                  updateTime
                }
                angefragterTerminZumTausch {
                  profil {
                   vorname
                   nachname
                  }
                }
                status {
                  kurzbezeichnung
                }
              }
            }
        }`,
    });

    const response = await request;
    if (response) {
      return response.getAnfragenForTermintausch;
    }
  }

  /**
   *
   * @returns {any}
   */
  async getOffeneAnfragenForTermintausch(page, pagesize) {
    const request = metis.metisRequest({
      query: `
        query{
          getOffeneAnfragenForTermintausch(page:  ${page}, pagesize: ${pagesize}) {
              totalElements
              totalPages
              termintauschAnfragen {
                id
                anfrager {
                  vorname
                  nachname
                }
                terminZumTausch {
                  terminnr
                  veranstnr
                  kurs {
                    kursnr
                    kursart {
                      bezeichnung
                    }
                    kursbez
                  }
                  raum {
                    raumnr
                  }
                  unterrichtsfach {
                    fachnr
                    fachbez
                  }
                  terminFarbe {
                    farbcode
                    bezeichnung
                  }
                  profil {
                   vorname
                   nachname
                  }
                  bezeichnung
                  datum
                  veranstvonz
                  veranstbisz
                  veranstort {
                    anzeigename
                  }
                  createTime
                  updateTime
                }
                angefragterTerminZumTausch {
                  terminnr
                  veranstnr
                  kurs {
                    kursnr
                    kursart {
                      bezeichnung
                    }
                    kursbez
                    onlineanteil
                  }
                  raum {
                    raumnr
                  }
                  unterrichtsfach {
                    fachnr
                    fachbez
                  }
                  terminFarbe {
                    farbcode
                    bezeichnung
                  }
                  bezeichnung
                  datum
                  veranstvonz
                  veranstbisz
                  veranstort {
                    anzeigename
                  }
                  profil {
                   vorname
                   nachname
                  }
                  createTime
                  updateTime
                }
                status {
                  kurzbezeichnung
                }
              }
            }
        }`,
    });

    const response = await request;
    if (response) {
      return response.getOffeneAnfragenForTermintausch;
    }
  }


  /**
   *
   * @returns {any}
   */
  async getFilteredDozentKursTermine(page, pagesize, filter) {
    // console.log(`
    // query{
    //   getFilteredDozentKursTermine(
    //   page: ${page}
    //   pagesize: ${pagesize}
    //   filter: ${filter}
    //   sort: TERMIN_UP
    // )`);
    const request = metis.metisRequest({
      query: `
        query{
          getFilteredDozentKursTermine(
          page: ${page}
          pagesize: ${pagesize}
          filter: ${filter}
          sort: TERMIN_UP
        ) {
          totalElements
          totalPages
          terminKurse {
            terminnr
            veranstnr
            kurs {
              kursnr
              kursart {
                bezeichnung
              }
              kursbez
              onlineanteil
              moodleLink
            }
            raum {
              raumnr
            }
            unterrichtsfach {
              fachnr
              fachbez
            }
            terminFarbe {
              farbcode
              bezeichnung
            }
            ausstattvarindex
            belegtbisz
            belegtvonz
            bewirtet
            bezeichnung
            datum
            displays
            listenausdruck
            persanzahl
            persanzahltats
            persanzbewirtet
            veranstvonz
            stunden
            veranstbisz
            veranstort {
              anzeigename
            }
            zausstatt
            prgname
            bemerkung
            createTime
            updateTime
          }
        }
        }`,
    });

    const response = await request;
    if (response) {
      return response.getFilteredDozentKursTermine;
    }
  }

  /**
   *
   * @returns {any}
   */
  async getKursTermine(kursnr) {
    const request = metis.metisRequest({
      query: `
        query{
         getKursTermine(
          mandantennummer: ${wp.mandantennummer}
          kursnr: "${kursnr}"
        ) {
          terminnr
          veranstnr
          kurs {
            kursnr
            kursart {
              bezeichnung
            }
            kursbez
            onlineanteil
          }
          raum {
            raumnr
          }
          unterrichtsfach {
            fachnr
            fachbez
          }
          terminFarbe {
            farbcode
            bezeichnung
          }
          ausstattvarindex
          belegtbisz
          belegtvonz
          bewirtet
          bezeichnung
          datum
          displays
          listenausdruck
          persanzahl
          persanzahltats
          persanzbewirtet
          veranstvonz
          stunden
          veranstbisz
          veranstort {
            anzeigename
          }
          zausstatt
          prgname
          bemerkung
          createTime
          updateTime
        }
      }`,
    });

    const response = await request;
    if (response) {
      return response.getKursTermine;
    }
  }

  /**
   *
   * @returns {any}
   */
  async getFilteredDozentKursTermineForTermintausch(page, pagesize, filter, sort = 'TERMIN_UP') {
    const request = metis.metisRequest({
      query: `
        query{
          getFilteredDozentKursTermineForTermintausch(
          page: ${page}
          pagesize: ${pagesize}
          filter: ${filter}
          sort: ${sort}
        ) {
          totalElements
          totalPages
          terminKurse {
            terminnr
            veranstnr
            kurs {
              kursnr
              kursart {
                bezeichnung
              }
              kursbez
              onlineanteil
            }
            raum {
              raumnr
            }
            unterrichtsfach {
              fachnr
              fachbez
            }
            terminFarbe {
              farbcode
              bezeichnung
            }
            belegtbisz
            belegtvonz
            bezeichnung
            datum
            veranstvonz
            veranstbisz
            veranstort {
              anzeigename
            }
            createTime
            updateTime
          }
        }
        }`,
    });

    const response = await request;
    if (response) {
      return response.getFilteredDozentKursTermineForTermintausch;
    }
  }

  /**
   *
   * @returns {any}
   */
  async getDozentKursTermineForTermintausch(page, pagesize, terminnr, veranstnr, filter) {
    const request = metis.metisRequest({
      query: `
        query{
          getDozentKursTermineForTermintausch(
            page: ${page}
            pagesize: ${pagesize}
            terminnr: ${terminnr}
            veranstnr: ${veranstnr}
            tauschterminFilter: ${filter}
          ) {
            totalElements
            totalPages
            terminKurse {
              terminnr
              veranstnr
              kurs {
                kursnr
                kursart {
                  bezeichnung
                }
                kursbez
                onlineanteil
              }
              raum {
                raumnr
              }
              unterrichtsfach {
                fachnr
                fachbez
              }
              terminFarbe {
                farbcode
                bezeichnung
              }
              profil {
                vorname
                nachname
              }
              belegtbisz
              belegtvonz
              bezeichnung
              datum
              veranstvonz
              veranstbisz
              veranstort {
                anzeigename
              }
              createTime
              updateTime
            }
          }
        }`,
    });

    const response = await request;
    if (response) {
      return response.getDozentKursTermineForTermintausch;
    }
  }

  async createTermintauschAnfragen(terminnr, veranstnr, angefragteTermineZumTausch) {
    console.log(`
        mutation {
            createTermintauschAnfragen(
            terminnr: ${terminnr}
            veranstnr: ${veranstnr}
            angefragteTermineZumTausch: ${angefragteTermineZumTausch}
          )
        }`);
    const request = metis.metisRequest({
      query: `
        mutation {
            createTermintauschAnfragen(
            terminnr: ${terminnr}
            veranstnr: ${veranstnr}
            angefragteTermineZumTausch: ${angefragteTermineZumTausch}
          )
        }`,
    });

    const response = await request;
    if (response) {
      return response.createTermintauschAnfragen;
    }
  }

  /**
   *
   * @returns {any}
   */
  async getFilteredUserTermine(page, pagesize, filter) {
    // console.log(`
    // query{
    //   getFilteredUserTermine(
    //   page: ${page}
    //   pagesize: ${pagesize}
    //   filter: ${filter}
    //   sort: TERMIN_UP
    // )`);
    const request = metis.metisRequest({
      query: `
        query{
          getFilteredUserTermine(
          page: ${page}
          pagesize: ${pagesize}
          filter: ${filter}
          sort: TERMIN_UP
        ) {
          totalElements
          totalPages
          terminKurse {
            terminnr
            veranstnr
            kurs {
              kursnr
              kursart {
                bezeichnung
              }
              kursbez
              onlineanteil
              moodleLink
            }
            raum {
              raumnr
            }
            unterrichtsfach {
              fachbez
            }
            terminFarbe {
              farbcode
              bezeichnung
            }
            ausstattvarindex
            belegtbisz
            belegtvonz
            bewirtet
            bezeichnung
            datum
            displays
            listenausdruck
            persanzahl
            persanzahltats
            persanzbewirtet
            veranstvonz
            stunden
            veranstbisz
            veranstort {
              anzeigename
            }
            zausstatt
            prgname
            bemerkung
            createTime
            updateTime
          }
        }
        }`,
    });

    const response = await request;
    if (response) {
      return response.getFilteredUserTermine;
    }
  }

  async getOffeneKurseForTerminwahl() {
    const request = await metis.metisRequest({
      query: `
        query{
          getOffeneKurseForTerminwahl(page: 1, pagesize: 100){
            totalElements
            totalPages
            kurse {
              kursnr
              kursbez
              anfang
              ende
              veranstaltungsort {
                ort
              }
            }
          }
        }`,
    });
    const response = await request;

    console.log(response);

    if (response) {
      return response.getOffeneKurseForTerminwahl;
    }
  }

  async getTerminplanKurs(kursnr) {
    const request = await metis.metisRequest({
      query: `
        query{
          getTerminplanKurs(kursnr: "${kursnr}"){
            kurs {
              kursnr
              anfang
              ende
              anztln
              anzvorm
              kursbez
              stunden
              abBez
              abArt
              dauer
            }
            gesamtSollstunden
            sollstunden
            reservierteStunden
            reserveInProzent
            angenommeneStunden
            terminplanUnterrichtsfaecher {
              unterrichtsfach {
                fachnr
                fachbez
                info
                massnahmenabschnitt
              }
              sollstunden
            }
            dozentTerminKursMonate {
              bezeichnung
              dozentTerminKurse {
                nummer
                von
                bis
                datum
                stunden
                ausgewaehlt
                status {
                  type
                  message
                }
              }
            }
          }
        }`,
    });
    const response = await request;
    if (response) {
      return response.getTerminplanKurs;
    }
  }

  async getTerminplanKursValues(kursnr) {
    const request = await metis.metisRequest({
      query: `
        query{
          getTerminplanKurs(kursnr: "${kursnr}"){
            angenommeneStunden
          }
        }`,
    });
    const response = await request;
    if (response) {
      return response.getTerminplanKurs;
    }
  }

  async getDozentTerminwahl(kursnr) {
    const request = await metis.metisRequest({
      query: `
        query{
          getDozentTerminwahl(kursnr: "${kursnr}"){
            id
            terminKurs {
              terminnr
              veranstnr
              kurs {
                kursnr
                kursart {
                  bezeichnung
                  sortierungsnr
                }
                kursOnline {
                  onlineBezeichnung
                }
                anfang
                anztln
                anzvorm
                ende
                kursbez
                maxtln
                mintln
                planung
                abBez
                abArt
                unterrichtsfaecher {
                  fachnr
                  fachbez
                  info
                  massnahmenabschnitt
                }
                foerderfaehig
                dauer
              }
              unterrichtsfach {
                fachnr
                fachbez
                info
                massnahmenabschnitt
              }
              terminFarbe {
                farbcode
                bezeichnung
              }
              bezeichnung
              datum
              veranstvonz
              stunden
              veranstbisz
            }
            status {
              kurzbezeichnung
              langbezeichnung
            }
            terminZugesagt
          }
        }`,
    });
    const response = await request;
    if (response) {
      return response.getDozentTerminwahl;
    }
  }

  async updateKursanfrageForTerminwahl(terminKursNummer, zugesagt) {

    const request = await metis.metisRequest({
      query: `
        mutation {
          updateKursanfrageForTerminwahl(kursnr: "${terminKursNummer}", zugesagt: ${zugesagt ? 'J' : 'N'})
        }
      `,
    });
    const response = await request;
    if (response) {
      return response.updateKursanfrageForTerminwahl;
    }
  }

  async getAbgelehnteKurseForTerminwahl() {
    const request = await metis.metisRequest({
      query: `
        {
          getAbgelehnteKurseForTerminwahl(page: 1, pagesize: 1000) {
            totalElements
            totalPages
            kurse {
              kursnr
              kursbez
              anfang
              ende
              veranstaltungsort {
                ort
              }
            }
          }
        }
      `,
    });
    const response = await request;
    if (response) {
      return response.getAbgelehnteKurseForTerminwahl;
    }
  }

  async getAngenommeneKurseForTerminwahl() {
    const request = await metis.metisRequest({
      query: `
        {
          getAngenommeneKurseForTerminwahl(page: 1, pagesize: 1000) {
            totalElements
            totalPages
            kurse {
              kursnr
              kursbez
              anfang
              ende
              veranstaltungsort {
                ort
              }
            }
          }
        }
      `,
    });
    const response = await request;
    if (response) {
      return response.getAngenommeneKurseForTerminwahl;
    }
  }

  async updateAllUserDozentTerminwahl(kursnr, bool) {

    const request = await metis.metisRequest({
      query: `
        mutation {
          updateAllUserDozentTerminwahl(kursnr: "${kursnr}", terminZugesagt: ${bool ? 'J' : 'N'})
        }
      `,
    });
    const response = await request;
    if (response) {
      return response.updateAllUserDozentTerminwahl;
    }
  }

  async updateUserDozentTerminwahl(terminKursNummer, bool) {

    const request = await metis.metisRequest({
      query: `
        mutation {
          updateUserDozentTerminwahl(terminKursNummer: ${terminKursNummer}, terminZugesagt: ${bool ? 'J' : 'N'})
        }
      `,
    });
    const response = await request;
    if (response) {
      return response.updateUserDozentTerminwahl;
    }
  }

  async alleTermintauschAnfragenAblehnen() {
    const request = await metis.metisRequest({
      query: `
        mutation {
          alleTermintauschAnfragenAblehnen
        }
      `,
    });
    const response = await request;
    if (response) {
      return response.alleTermintauschAnfragenAblehnen;
    }
  }

  async termintauschZustimmen(dozentTermintauschId) {
    const request = await metis.metisRequest({
      query: `
        mutation {
            termintauschZustimmen(dozentTermintauschId: ${dozentTermintauschId})
        }
      `,
    });
    const response = await request;
    if (response) {
      return response.termintauschZustimmen;
    }
  }

  async termintauschAblehnen(dozentTermintauschId) {
    const request = await metis.metisRequest({
      query: `
        mutation {
            termintauschAblehnen(dozentTermintauschId: ${dozentTermintauschId})
        }
      `,
    });
    const response = await request;
    if (response) {
      return response.termintauschAblehnen;
    }
  }

  async deleteTermintausch(dozentTermintauschId) {
    const request = await metis.metisRequest({
      query: `
        mutation {
            deleteTermintausch(dozentTermintauschId: ${dozentTermintauschId})
        }
      `,
    });
    const response = await request;
    if (response) {
      return response.deleteTermintausch;
    }
  }

  async getTerminfarben() {
    const request = await metis.metisRequest({
      query: `
        {
          getTerminfarben {
            farbcode
            bezeichnung
          }
        }
      `,
    });
    const response = await request;
    if (response) {
      return response.getTerminfarben;
    }
  }
}

export default Events;
